import { __awaiter } from "tslib";
import { useEffect, useState } from 'react';
import { getHaloEffectBaseData } from '../helpers/getHaloEffectBaseData';
const sponsoredHaloEffectWidgets = {
    games: undefined,
    movies: undefined,
    tv: undefined,
    anime: undefined,
};
export default function useSponsoredWikiCardState(props) {
    const { verticalType, isForced } = props;
    const [sponsoredContent, setSponsoredContent] = useState(null);
    useEffect(() => {
        const widget = sponsoredHaloEffectWidgets[verticalType];
        widget !== undefined ? setSponsoredContent(widget) : getHaloEffect();
        function getHaloEffect() {
            return __awaiter(this, void 0, void 0, function* () {
                const widget = yield getHaloEffectBaseData(verticalType, isForced);
                sponsoredHaloEffectWidgets[verticalType] = widget !== null && widget !== void 0 ? widget : null;
                setSponsoredContent(widget);
            });
        }
    }, [verticalType]);
    return sponsoredContent !== null && sponsoredContent !== void 0 ? sponsoredContent : null;
}
